import {
  CLARITY_SCRIPT_ID,
  GA4_SCRIPT_ID,
  denyAnalyticsProviders,
  enableAnalyticsProviders,
} from './analytics'
import {
  storeAnalyticsConsent,
} from './analyticsConsentState'

export { CLARITY_SCRIPT_ID, GA4_SCRIPT_ID } from './analytics'
export {
  ANALYTICS_CONSENT_KEY,
  ANALYTICS_CONSENT_MAX_AGE_MS,
  ANALYTICS_CONSENT_VERSION,
  readAnalyticsConsent,
  storeAnalyticsConsent,
  type AnalyticsDecision,
  type StoredAnalyticsConsent,
} from './analyticsConsentState'

export function enableAnalytics(suppressClarity = false): void {
  enableAnalyticsProviders({ suppressClarity })
}

function expireCookie(name: string): void {
  const hostParts = window.location.hostname.split('.')
  const domains = ['', window.location.hostname, `.${window.location.hostname}`, hostParts.length > 2 ? `.${hostParts.slice(-2).join('.')}` : '']
  for (const domain of new Set(domains)) {
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax${domain ? `; domain=${domain}` : ''}`
  }
}

export function clearClarityCookies(): void {
  for (const name of ['_clck', '_clsk', 'CLID', 'ANONCHK', 'MR', 'MUID', 'SM']) expireCookie(name)
}

export function clearGoogleAnalyticsCookies(): void {
  for (const entry of document.cookie.split(';')) {
    const name = entry.split('=', 1)[0]?.trim()
    if (
      name
      && (
        name === '_gid'
        || name.startsWith('_ga')
        || name.startsWith('_gat')
        || name.startsWith('_gac')
        || name.startsWith('_gcl')
      )
    ) expireCookie(name)
  }
}

export function denyAnalytics(reloadIfActive = true): void {
  const wasActive = Boolean(
    window.clarity
    || window.gtag
    || document.getElementById(CLARITY_SCRIPT_ID)
    || document.getElementById(GA4_SCRIPT_ID),
  )
  storeAnalyticsConsent('denied')
  // Clear stale first-party cookies even when this document never loaded the
  // runtime (for example after consent expiry or a policy-version change).
  clearClarityCookies()
  clearGoogleAnalyticsCookies()
  if (wasActive) {
    denyAnalyticsProviders()
    if (reloadIfActive) window.location.reload()
  }
}

export function grantAnalytics(suppressClarity = false): void {
  storeAnalyticsConsent('granted')
  enableAnalytics(suppressClarity)
}
